export var LocalStorageKey = /*#__PURE__*/function (LocalStorageKey) {
  LocalStorageKey["CitationCount"] = "citationCount";
  LocalStorageKey["CouponEligibilityBreadcrumb"] = "c_bc";
  LocalStorageKey["CourseDashboardTourSeen"] = "course-dashboard-tour-seen";
  LocalStorageKey["CWCGuestAssignment"] = "cwc-guest-assignment-uuid";
  LocalStorageKey["CWCWritingToken"] = "writing-token";
  LocalStorageKey["GoBackUrl"] = "go-back-url";
  LocalStorageKey["MyFolderTour"] = "my-folder-tour";
  LocalStorageKey["PaQQuestionBody"] = "questionBody";
  LocalStorageKey["SHOW_ALL_STEPS"] = "show-all-steps";
  LocalStorageKey["UnlimitedPaqModalSeen"] = "unlimited-paq-modal-seen";
  return LocalStorageKey;
}({});
export var CWF_TEAM_NAME = 'CWF';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/LocalStorage/constants.js
// module id = 1241
// module chunks = 11